module.exports = __webpack_public_path__ + "img/Active_Power_Import_Total.1eb1936b.jpeg";